module.exports = __webpack_public_path__ + "static/media/goat_hay_stack.3b4fe552.png";